<template>
  <div class="customer_details">
    <div class="company_information">
      <div class="company_name">{{ queryData.enterpriseName }}</div>

      <div class="company_details">
        <div style="margin-right: 300px">
          <i style="color: #17757a; font-weight: 700" class="el-icon-orange"></i> 企业官网：
        </div>
        <div class="position" style="margin-right: 85px">
          <i style="color: #17757a; font-weight: 700" class="el-icon-location-outline"></i>
          所在地区：{{ queryData.nation }}—{{ queryData.province }}—{{ queryData.city }}
        </div>
        <div class="created_time">
          <i style="color: #17757a; font-weight: 700" class="el-icon-stopwatch"></i>
          成立日期：{{ queryData.establishTime }}
        </div>
      </div>

      <div class="text_description" v-if="queryData.companyProfiles">
        {{ queryData.companyProfiles | quantityFilters(that) }}
        <span
          class="more"
          v-if="queryData.companyProfiles.length > 200 && textShow == false"
          @click="textShow = true"
          >更多</span
        >
        <span class="more" v-else @click="textShow = false">收起</span>
      </div>
    </div>
    <!-- 业务信息 -->
    <div class="service_information">
      <div class="service_information_title">业务信息</div>
      <div class="service_information_details">
        <div class="service_information_details_item">
          <div>签约时间</div>
          <div>{{ queryData.consultingTime }}</div>
        </div>

        <div class="service_information_details_item">
          <div>招聘潜力</div>
          <div>{{ queryData.recruitPotential }}</div>
        </div>

        <div class="service_information_details_item">
          <div>确定需求</div>
          <div>{{ queryData.confirmDemand }}</div>
        </div>

        <div class="service_information_details_item">
          <div>潜在需求</div>
          <div>{{ queryData.concealDemand }}</div>
        </div>

        <div class="service_information_details_item">
          <div>商务经理</div>
          <div>{{ queryData.englishName }}</div>
        </div>

        <div class="service_information_details_item">
          <div>客户经理</div>
          <div v-if="queryData.customerManager">{{ queryData.customerManager }}</div>
          <div v-else class="not_yet" @click="setCustomerManager">待分配</div>
        </div>
      </div>
    </div>
    <!-- table表格 -->
    <div class="tables">
      <div class="table_title">已完成项目 {{ tableData.length }}</div>
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{ color: '#333' }"
        @sort-change="sortChange"
      >
        <el-table-column label="序号" align="center">
          <template v-slot="{ row }">
            <div>
              {{ row.id }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="企业信息" align="center" :show-overflow-tooltip="true">
          <template v-slot="{ row }">
            <div class="enterpriseName">
              {{ row.corporateName }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="招聘职位" align="center" :show-overflow-tooltip="true">
          <template v-slot="{ row }">
            <div>
              {{ row.recruitmentPosition }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="工作地点" align="center" :show-overflow-tooltip="true">
          <template v-slot="{ row }">
            <div>
              {{ row.dutyStation }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="启动时间" align="center" :show-overflow-tooltip="true">
          <template v-slot="{ row }">
            <div>
              {{ row.startTime }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="当前项目进度" align="center" sortable="custom" prop="当前项目进度">
          <template v-slot="{ row }">
            <div>
              {{ row.projectSchedule }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="核心要求" align="center" width="637" :show-overflow-tooltip="true">
          <template v-slot="{ row }">
            <div>
              {{ row.coreRequirements }}
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="table_title">
        <span> 附件 {{ accessory.length }} </span>
        <el-button type="primary" @click="UploadDialogVisible = true">上传附件</el-button>
      </div>
      <el-table :data="accessory" style="width: 100%" :header-cell-style="{ color: '#333' }">
        <el-table-column label="序号" align="center">
          <template v-slot="{ row }">
            <div>
              {{ row.clueCode }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="附件名称" align="center">
          <template v-slot="{ row }">
            <div>
              {{ row.accessoryName }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="上传者" align="center">
          <template v-slot="{ row }">
            <div>
              {{ row.createName }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="上传时间" align="center">
          <template v-slot="{ row }">
            <div>
              {{ row.createTime }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center">
          <template v-slot="{ row }">
            <div class="accessory_options">
              <div @click="download(row)">下载</div>
              <div @click="remove(row)">删除</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 选择客户经理弹窗 -->
    <div class="customer_manager_dialog">
      <el-dialog
        @close="customerManagerDialogClose"
        :visible.sync="customerManagerDialog"
        width="30%"
        top="40vh"
      >
        <div class="dialogHead">
          <div class="line"></div>
          <div class="txt">选择客户经理</div>
        </div>
        <div class="customer_manager_main">
          <div class="customer_manager_main_label">客户经理：</div>
          <el-select
            style="width: 258px"
            v-model="customerManagerValue"
            placeholder="请选择客户经理"
          >
            <el-option
              v-for="(item, index) in customerManagerOptions"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </div>
        <div class="button">
          <div class="add" @click="addConfirmBtn">确定</div>
          <div class="cancel" @click="customerManagerDialog = false">取消</div>
        </div>
      </el-dialog>
    </div>
    <!-- 上传附件对话框 -->
    <el-dialog title="提示" :visible.sync="UploadDialogVisible" width="30%">
      <div class="upload">
        <el-upload action multiple :http-request="upload">
          <el-button size="medium" type="primary">点击上传</el-button>
        </el-upload>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getClient } from '@/api/projectCenter'
import {
  getUser,
  updateClue,
  deleteAccessory,
  fileDownloadSingle,
  uploadAdmin,
  addAccessory
} from '@/api/businessCenter'

const editObj = Object.freeze({
  clueCode: '', //线索编号
  customerManager: '' //客户经理
})
const uploadObj = Object.freeze({
  accessoryName: '', // 附件名称
  accessoryUrl: '', // 附件地址
  clueCode: '', //线索编号
  createName: '', //上传者
  createTime: '', //上传时间
  id: 0
})
export default {
  components: {},
  data() {
    return {
      UploadDialogVisible: false, //上传附件弹窗
      uploadFile: { ...uploadObj }, //上传的文件
      editForm: { ...editObj }, //请求参数
      textShow: false,
      that: this,
      query: {
        baseParam: {
          pageNum: 1,
          pageSize: 10
        },
        clueCode: '',
        order: 'desc',
        orderType: null
      }, //查询请求发送的数据
      queryData: {}, //查询返回的数据
      customerManagerDialog: false, // 选择客户经理 dialog
      customerManagerValue: '', // 选择的客户经理
      // 客户经理下拉项
      customerManagerOptions: [],
      tableData: [],
      accessory: []
    }
  },
  filters: {
    quantityFilters(value, that) {
      let str = value
      if (str.length > 200) {
        if (that.textShow) {
          str = value
        } else {
          str = value.slice(0, 200) + '...'
        }
      }
      return str
    }
  },
  computed: {
    clueCode() {
      return this.$route.query.clueCode
    }
  },
  watch: {},
  methods: {
    async search() {
      this.query.clueCode = this.clueCode
      const { data: res } = await getClient(this.query)
      if (res.resultCode == 200) {
        this.queryData = res.data.list[0]
        if (res.data.list[0].projectCenters) {
          this.tableData = res.data.list[0].projectCenters
        }
        if (res.data.list[0].accessorys) {
          this.accessory = res.data.list[0].accessorys
        }
      }
    },
    async setCustomerManager() {
      const { data: res } = await getUser()
      if (res.resultCode === 200) {
        this.customerManagerOptions = res.data.customerManager
      } else {
        this.$message.error('获取客户经理失败！')
      }
      this.customerManagerDialog = true
    },
    async addConfirmBtn() {
      this.queryData.customerManager = this.customerManagerValue
      this.editForm.customerManager = this.customerManagerValue
      const { data: res } = await updateClue(this.editForm)
      if (res.resultCode === 200) {
        this.search()
      }
      this.customerManagerDialog = false
    },
    // 关闭选择客户经理弹窗
    customerManagerDialogClose() {
      this.customerManagerOptions = []
    },
    sortChange(column) {
      console.log({ column })
    },
    // 下载单个附件
    async download(row) {
      console.log(row)
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      fileDownloadSingle({
        url: row.accessoryUrl
      })
        .then((result) => {
          loading.close()
          let blob = new Blob([result.data])
          let href = window.URL.createObjectURL(blob) // 创建新的URL表示指定的blob对象
          const a = document.createElement('a') // 创建a标签
          a.style.display = 'none'
          a.href = href // 指定下载'链接
          let date = new Date()
          let year = date.getFullYear()
          let month = date.getMonth() + 1
          month = month < 10 ? '0' + month : month
          let day = date.getDate()
          day = day < 10 ? '0' + day : day
          let hours = date.getHours()
          hours = hours < 10 ? '0' + hours : hours
          let minutes = date.getMinutes()
          minutes = minutes < 10 ? '0' + minutes : minutes
          a.download = '' + year + month + day + hours + minutes + '-' + row.accessoryName + '.zip' //指定下载文件名
          a.click() //触发下载
          window.URL.revokeObjectURL(a.href) //释放URL对象
          if (document.body.contains(a)) {
            document.body.removeChild(a) //释放标签
          }
          this.$message.success('下载附件成功！')
        })
        .catch((err) => {
          this.$message.error('下载附件失败！!')
        })
    },
    // 删除附件
    async remove(row) {
      const { data: res } = await deleteAccessory({
        id: row.id
      })
      if (res.resultCode === 200) {
        this.$message.success('删除附件成功！')
        this.search()
      } else {
        this.$message.error('删除附件失败！')
      }
    },
    //上传附件
    async upload(file) {
      let time = new Date()
      this.uploadFile.createTime = this.$moment(time).format('YYYY-MM-DD HH:mm:ss')
      this.uploadFile.createName = sessionStorage.getItem('userName')
      this.uploadFile.clueCode = this.clueCode
      this.uploadFile.accessoryName = file.file.name
      let arr = []
      const form = new FormData()
      form.append('files', file.file)
      form.append('Authorization', this.Authorization)
      const { data: res } = await uploadAdmin(form)
      if (res.resultCode == 200) {
        this.uploadFile.accessoryUrl = res.data.fileLook[0]
        arr.push(this.uploadFile)
        const { data: res1 } = await addAccessory(arr)
        if (res1.resultCode === 200) {
          this.UploadDialogVisible = false
          this.$message.success('附件上传成功！')
          this.search()
        } else {
          this.$message.error('附件上传失败！')
        }
      } else {
        this.$message.error('333')
      }
    }
  },
  created() {
    this.editForm.clueCode = this.$route.query.clueCode
    this.search()
  },
  mounted() {}
}
</script>
<style scoped lang="less">
.customer_details {
  overflow: auto;
  .company_information {
    border-radius: 4px;
    background-color: #fff;
    padding: 20px 145px 25px 20px;
    margin-bottom: 12px;
    .company_name {
      font-size: 18px;
      font-weight: 700;
      color: #333333;
    }

    .company_details {
      display: flex;
      margin: 21px 0 25px 0;
      color: #333333;
      font-size: 14px;
    }

    .text_description {
      color: #1a1f33;
      font-size: 14px;
    }
    .more {
      font-size: 14px;
      color: #17757a;
      cursor: pointer;
    }
  }
  .service_information {
    background-color: #fff;
    border-radius: 4px;
    display: flex;
    height: 115px;
    margin-bottom: 12px;
    .service_information_title {
      font-size: 14px;
      font-weight: 700;
      color: #333333;
      width: 161px;
      height: 100%;
      padding: 19px 0 0 27px;
      box-sizing: border-box;
    }
    .service_information_details {
      display: flex;

      .service_information_details_item {
        display: flex;
        flex-direction: column;
        height: 100%;
        color: #333333;
        font-size: 14px;
        justify-content: space-evenly;
        align-items: center;
        margin-right: 70px;

        .not_yet {
          color: #17757a;
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
  }
  .tables {
    background-color: #fff;
    .enterpriseName {
      width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .table_title {
      color: #333333;
      font-size: 16px;
      font-weight: 700;
      height: 70px;
      display: flex;
      align-items: center;
      padding-left: 36px;
      span {
        margin-right: 20px;
      }
    }
    .accessory_options {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #17757a;
      font-size: 14px;
      > div {
        margin-right: 10px;
        cursor: pointer;
      }
    }
  }
  .customer_manager_dialog {
    /deep/.el-dialog__header {
      padding: 0;
    }
    /deep/.el-dialog__body {
      padding: 0 0 30px 0px;
    }
    /deep/.el-input__inner {
      width: 258px;
      height: 32px;
      line-height: 32px;
    }
    /deep/.el-select__caret {
      line-height: 32px;
    }
    .customer_manager_main {
      display: flex;
      height: 32px;
      margin-bottom: 28px;
      text-align: right;
      .customer_manager_main_label {
        line-height: 32px;
        width: 156px;
      }
    }
    .dialogHead {
      display: flex;
      align-items: center;
      height: 54px;
      padding-left: 16px;
      .line {
        width: 4px;
        height: 20px;
        background-color: #17757a;
        border-radius: 2px;
        margin-right: 8px;
      }
      .txt {
        color: #333333;
        font-size: 16px;
        font-weight: 700;
      }
    }
    .button {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      .add {
        color: #fff;
        width: 64px;
        height: 33px;
        background-color: #17757a;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        border-radius: 4px;
        cursor: pointer;
      }
      .cancel {
        color: #17757a;
        width: 64px;
        height: 33px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        border-radius: 4px;
        border: 1px solid #17757a;
        margin-left: 34px;
        cursor: pointer;
      }
    }
  }
}
.upload {
  display: flex;
  justify-content: center;
}
::v-deep .upload .el-upload-list {
  display: none;
}
</style>
